import React from "react"
import {Button} from "antd"

function TableButtonComponent({data,handleClick,icon,buttonColor}){
    return <Button onClick={handleClick} style={{border:`2px solid ${buttonColor}`,borderRadius:"22px",display:"flex",justifyContent:"space-around",alignItems:"center",gap:"1rem",color:buttonColor,padding:"6px",width:"5rem",margin:"auto"}}>{data?data:"Test Redux"}</Button>        
}

export default TableButtonComponent